// extracted by mini-css-extract-plugin
module.exports = {"containerLinks":"MobileAppLinks_containerLinks__2bs33","buttonLink":"MobileAppLinks_buttonLink__10S5R"};